import React, { PureComponent } from "react";
import { NavLink, withRouter } from "react-router-dom";
import classnames from "classnames";
import { Trigger } from "@ss/mtd-react/lib/utils/react";
import { Icon, Dropdown, Menu, Input, Tooltip, Popover } from "@ss/mtd-react3";
import LOGO_PATH_Black from "@/assets/images/px_logo_black.png";
import LOGO_PATH_White from "@/assets/images/px_logo_white.png";
import MarketUploadImg from "@/assets/images/marketUploadImg.png";
import "./style.scss";
import stickybits from "stickybits";
import { fetchData, getSSOLogoutUrl } from "@/utils";
import {
    MenuArr,
    CodeComponentLibrary,
    Resource_Type_Identifier
} from "@/utils/constant/teamManagement";
import UploadModal from "@/components/upload-component/UploadModal";
import {
    getUserInfo,
    getOwnTeam,
    hasBrandManPermission,
    getPixelManPermission
} from "@/utils/index";
import PropTypes from "prop-types";
import urls from "../../urls";
import KEETA from "@/assets/images/Keeta Brand Assets Black.png";
import KEETA_WHITE from "@/assets/images/Keeta Brand Assets White.png";
import SearchIcon from "@/assets/images/search-icon.png";
import SearchIconWhite from "@/assets/images/search-icon-white.png";
import UploadIcon from "@/assets/images/upload-icon.png";
import UploadIconWhite from "@/assets/images/upload-icon-white.png";
const MenuItem = Menu.Item;

const navItems = [{
    materialName: "Brand Guidelines",
    path: "/brand-guidelines",
    isOpen: true
},
{
    materialName: "Marketing Resources",
    path: "/in-app-specs",
    isOpen: false
},
{
    materialName: "Brand Designs",
    path: "/brand-designs",
    isOpen: false
},
    // "UI/UX",
    // "Basic Assets"
];

class Header extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: {},
            teamList: [],
            hasShowTeamList: false,
            teamListTimer: null,
            showUploadListState: false,
            showUploadModal: false,
            activeTeamId: "",
            stickyInstance: null,
            hasBrandManPermission: false,
            selectedKeys: "",
            hasDataDashboardAuth: false,
            showTeamDataDashboard: false,
            hasAuthCodeManPermission: false,
            hasUploadPermission: false,
            isExpanded: false, // 控制搜索框是否显示的状态
            inputValue: ""
        };
        this.inputRef = React.createRef();
    }
    async componentDidMount() {
        const stickyInstance = stickybits(".header-sticky", {});

        this.setState({
            stickyInstance,
        });
        // setTimeout(() => {//灰度功能不好用，临时添加的
        //     if (userInfo && userInfo.userMis) {
        //         cookie.set('px_mis', userInfo.userMis, 10 * 24 * 3600);
        //     }
        // }, 1000 * 5);
    }

    componentWillUnmount() {
        const { stickyInstance } = this.state;
        if (stickyInstance) {
            stickyInstance.cleanup();
        }
    }
    // 检查上传权限
    checkPermission = async () => {
        try {
            const response = await fetchData(
                urls.brandAggregation.checkUploadPermission
            );
            this.setState({
                hasUploadPermission: response
            });
        } catch (error) {
            console.error("检查权限失败:", error);
        }
    };
    handleShowTeamList = () => {
        const { teamListTimer } = this.state;
        if (teamListTimer) {
            clearTimeout(teamListTimer);
        }
        this.setState({
            hasShowTeamList: true,
            teamListTimer: null
        });
    };
    handleCloseTeamList = e => {
        const { teamListTimer } = this.state;
        if (teamListTimer) {
            return;
        }
        const timer = setTimeout(() => {
            this.setState({
                hasShowTeamList: false,
                teamListTimer: null
            });
        }, 100);
        this.setState({
            teamListTimer: timer
        });
    };

    renderUploadPopUp = () => {
        return (
            <Popover
                trigger="click"
                placement="bottomLeft"
                content={
                    <div style={{ zIndex: 3001, minWidth: 216.69 }}>
                        <ul className="avatar-popup">
                            <NavLink
                                to={`/asset-management?type=${MenuArr[1].value}`}
                            >
                                <li>Asset Management</li>
                            </NavLink>
                            <NavLink
                                to={`/asset-management?type=${MenuArr[2].value}`}
                            >
                                <li>My Downloads</li>
                            </NavLink>
                            {hasBrandManPermission && (
                                <NavLink
                                    to={`/asset-management?type=${MenuArr[5].value}`}
                                >
                                    <li>Classification Management</li>
                                </NavLink>
                            )}
                            <a href={getSSOLogoutUrl()}>
                                <li>Log out</li>
                            </a>
                        </ul>
                    </div>
                }
            ></Popover>
        );
    };
    renderPopup = (checkPermission = false) => {
        const { teamList, hasBrandManPermission } = this.state;
        const orgPath = localStorage.getItem("userOrg");
        const myTeam = teamList.find(item => item.teamMis === orgPath);
        return (
            <div style={{ zIndex: 3001, minWidth: 216.69 }}>
                <ul className="avatar-popup">
                    <NavLink to={`/asset-management?type=${MenuArr[1].value}`}>
                        <li>Asset Management</li>
                    </NavLink>

                    <NavLink to={`/asset-management?type=${MenuArr[2].value}`}>
                        <li>My Downloads</li>
                    </NavLink>
                    {hasBrandManPermission && (
                        <NavLink
                            to={`/asset-management?type=${MenuArr[5].value}`}
                        >
                            <li>Classification Management</li>
                        </NavLink>
                    )}
                    <a href={getSSOLogoutUrl()}>
                        <li>Log out</li>
                    </a>
                </ul>
            </div>
        );
    };
    jumpToUploadmanagement() {
        this.props.history.push("/uploadManagement");
    }
    handleCloseShowUpload = e => {};

    renderTeamListUpload = () => {
        const { teamList } = this.state;
        return (
            <ul className="nav-upload-list" style={{ width: 220 }}>
                {teamList.map(item => (
                    <li
                        key={item.teamId}
                        className="nav-upload-list-item"
                        onClick={() =>
                            this.setState({
                                activeTeamId: item.teamId,
                                showUploadModal: true,
                                showUploadListState: false
                            })
                        }
                    >
                        {item.teamNameShort}
                    </li>
                ))}
            </ul>
        );
    };

    jumpTo = url => {
        this.props.history.push(url);
    };

    renderMoreMenu = activeNavName => {
        return (
            <Menu
                inlineIndent={12}
                style={{ width: 160 }}
                selectedKeys={[activeNavName]}
            >
                <MenuItem
                    key="/human"
                    onClick={() => this.jumpTo("/human")}
                    className="header-more"
                >
                    <span>企业文化素材</span>
                </MenuItem>
                <MenuItem
                    key="/code"
                    className="header-more"
                    onClick={() => window.open(CodeComponentLibrary)}
                >
                    <span>代码组件库</span>
                </MenuItem>
            </Menu>
        );
    };

    renderSearch = () => {
        return (
            <div className="global-search-wrap">
                <Input
                    placeholder="搜索素材名称、关键词、标签、ID编号..."
                    prefix={<Icon type="search" />}
                    className="global-search-input"
                ></Input>
                {/* <RecentSearch></RecentSearch> */}
            </div>
        );
    };

    // 上传栏
    renderUpload = () => {
        const { showUploadListState, teamList } = this.state;
        return (
            <ul className="nav-upload-list">
                {teamList.length === 0 && (
                    <Tooltip
                        message="Please ask the team manager to activate the permission"
                        autoDestory
                    >
                        <li
                            className="nav-upload-list-item"
                            style={{ cursor: "not-allowed" }}
                        >
                            <span className="disable-upload flex-style">
                                上传团队资产
                                <span className="upload-recommond-title">
                                    推荐
                                </span>
                            </span>
                        </li>
                    </Tooltip>
                )}
                {teamList.length === 1 && (
                    <li className="nav-upload-list-item">
                        <span
                            className="flex-style"
                            onClick={() =>
                                this.setState({
                                    showUploadModal: true,
                                    activeTeamId: teamList[0].teamId
                                })
                            }
                        >
                            上传团队资产
                            <span className="upload-recommond-title">推荐</span>
                        </span>
                    </li>
                )}
                {teamList.length > 1 && (
                    <Trigger
                        popup={this.renderTeamListUpload}
                        align={{ points: ["tr", "tl"], offset: [-8, -4] }}
                        visible={showUploadListState}
                        onVisibleChange={v =>
                            this.setState({ showUploadListState: v })
                        }
                    >
                        <li className="nav-upload-list-item">
                            <div
                                className="flex-between"
                                style={{ width: "100%" }}
                            >
                                <span className="flex-style">
                                    上传团队资产
                                    <span className="upload-recommond-title">
                                        推荐
                                    </span>
                                </span>
                                <Icon
                                    type="right-thick"
                                    style={{ marginRight: 10 }}
                                ></Icon>
                            </div>
                        </li>
                    </Trigger>
                )}
                <li
                    className="nav-upload-list-item"
                    onClick={() =>
                        this.setState({
                            showUploadModal: true,
                            showUploadListState: false
                        })
                    }
                >
                    上传个人资产
                </li>
            </ul>
        );
    };

    handleIconClick = () => {
        this.setState({ isExpanded: true }, () => {
            setTimeout(() => {
                // 状态更新后聚焦输入框
                if (this.inputRef.current) {
                    this.inputRef.current.focus();
                }
            }, 500);
        });
    };

    handleInputBlur = () => {
        this.setState({ isExpanded: false });
    };

    handleInputEnter = () => {
        const { inputValue } = this.state;
        // this.props.history.push(
        //     `/search?keyword=${encodeURIComponent(inputValue)}&tabValue=${
        //         Resource_Type_Identifier.PX_IMAGE
        //     }`
        // );
        this.props.history.push(
            `/search-result?keyword=${encodeURIComponent(inputValue)}`
        );
    };

    // 计算属性：判断是否在首页
    get isHomePage() {
        const { pathname } = this.props.location;
        return pathname === "/assets-internal" || pathname === "/";
    }

    render() {
        const { userInfo, teamList, isExpanded, inputValue } = this.state;
        const { checkPermission, userAvatar } = userInfo;
        const {
            showUploadModal,
            activeTeamId,
            hasUploadPermission
        } = this.state;
        const {
            className,
            style,
            isSticky,
            activeNavName,
            isWhiteTheme,
            isOpcity,
            isNoBlur
        } = this.props;

        return (
            <header
                className="navbar header"
                style={{ backdropFilter: isNoBlur ? "none" : "blur(5px)" }}
            >
                <div className="leftSection-header">
                    <a href="/assets" className="logo-header">
                        <img
                            src={this.isHomePage ? KEETA_WHITE : KEETA}
                            alt="Keeta Brand Assets"
                            width={120}
                            height={40}
                        />
                    </a>
                    <div className="navLinks">
                        {navItems.map((item, index) => (
                            <MenuItem
                                key={index}
                                onClick={() => this.jumpTo(item.path)}
                                style={{
                                    color: this.isHomePage ? "#ffffff" : ""
                                }}
                                className={`navLink${
                                    item.path === activeNavName ? " active" : ""
                                }`}
                            >
                                {item.materialName}
                                {!item.isOpen && <Icon type="lock-o" style={{ marginLeft: 10, fontSize: 20}} />}
                            </MenuItem>
                        ))}
                    </div>
                </div>
                <div style={{ flex: 1 }}></div>
                <div className="px-header-operation-wrap">
                    <Input
                        prefix={
                            <Icon
                                type="search"
                                className={`search-icon  ${
                                    !isExpanded ? "expanded" : ""
                                }`}
                                style={{ color: "rgba(0,0,0,.9)" }}
                            />
                        }
                        value={inputValue}
                        onChange={e =>
                            this.setState({ inputValue: e.target.value })
                        }
                        type="text"
                        ref={this.inputRef}
                        className={`search-input ${
                            isExpanded ? "expanded" : ""
                        }`}
                        onBlur={this.handleInputBlur}
                        style={{ width: isExpanded ? "200px" : "0px" }}
                        onPressEnter={this.handleInputEnter}
                    />
                    <img
                        src={this.isHomePage ? SearchIconWhite : SearchIcon}
                        className={`search-icon-single ${
                            isExpanded ? "expanded" : ""
                        }`}
                        onClick={this.handleIconClick}
                    />
                </div>
            </header>
        );
    }
}
Header.defaultProps = {
    isWhiteTheme: false,
    isOpcity: false
};

Header.propTypes = {
    isWhiteTheme: PropTypes.bool,
    isOpcity: PropTypes.bool
};

export default withRouter(Header);

